export default __webpack_public_path__ + "static/media/remove_icon.76fedeb5.svg";